import StagedWorkflowFile from "../../components/StagedWorkfowFile/StagedWorkflowFile"
import { ScopeWorflowSectionProps } from "./ScopeWorkflows.types"
import "./ScopeWorkflows.css"
import Alert from "../../../../components/Alert/Alert"
import {QRCodeSVG} from 'qrcode.react'
import * as htmlToImage from "html-to-image"
import { useRef } from "react"
import AddStagedWorkflowForm from "./components/AddScopeWorkflowForm"
import ScopeWorkflowFormType from "../../../../utils/ScopeWorkflowFormType"
import { getDate } from "../../../../utils/utils"
import ConfirmationAlert from "../../../../components/ConfirmationAlert/ConfirmationAlert"
import { MAX_QR_CODE_CHARS } from "../../../../utils/constants"

const ScopeWorkflowsSection = (props: ScopeWorflowSectionProps) => {

  const {
    workflows,
    claddingMaterials,
    insulationMaterials,
    locations,
    showQRCode,
    showAddStageWorkflow,
    selectedWorkflows,
    selectedWorkflow,
    formType,
    scopeQRString,
    error,
    showDeleteConfirmation,
    onShowDeleteConfirmation,
    onSelectWorkflow,
    onCheckWorkflow,
    onOpenWorkflow,
    onHideQRCode,
    onHideStageWorkflow,
    onError,
    onSubmit,
    onDeleteWorkflow,
    onDuplicateWorkflow,
    canGenerateQRCode
  } = props

  const qrCodeRef = useRef(null)

  const downloadQRCode = () => {
    if (qrCodeRef.current === null) { return }
    htmlToImage
      .toPng(qrCodeRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a")
        link.href = dataUrl
        link.download = "qr-code.png"
        link.click()
      })
      .catch((error) => {
        onError(error)
      })
  }

  return (
    <div className="staged-workflows-container">
      {workflows.length > 0 && (
        <div className="staged-workflows-header-container">
          <p className="workflows-result-header">PIPE ID</p>
          <p className="workflows-result-header">SECTIONS</p>
          <p className="workflows-result-header">DATE</p>
          <p className="workflows-result-header"></p>
        </div>
      )}

      {workflows.map((workflow, key) => (
        <StagedWorkflowFile
          key={key}
          pipeId={workflow.pipe_id}
          isSelected={selectedWorkflow?.id === workflow.id}
          disabled={!canGenerateQRCode(key)}
          onSelect={() => onSelectWorkflow(workflow)}
          isChecked={selectedWorkflows.includes(key)}
          onCheck={() => onCheckWorkflow(key)}
          sections={JSON.parse(workflow.sections).length}
          date={getDate(workflow.date)}
          ellipsisMenu={[
            {
              item: "Open",
              onClick: () => onOpenWorkflow(ScopeWorkflowFormType.VIEW, workflow)
            },
            {
              item: "Duplicate",
              onClick: () => onDuplicateWorkflow(workflow)
            },
            {
              item: "Edit",
              onClick: () => onOpenWorkflow(ScopeWorkflowFormType.EDIT, workflow)
            },
            {
              item: "Delete",
              onClick: () => onShowDeleteConfirmation(true)
            }
          ]}
          onDoubleClick={() => onOpenWorkflow(ScopeWorkflowFormType.VIEW, workflow)}
        />
      ))}

      {workflows.length === 0 && error === undefined && (
        <div className="no-results-container">
          <p>No existing scope workflows.</p>
        </div>
      )}

      {workflows.length === 0 && error !== undefined && (
        <div className="no-results-container">
          <p>{`Failed to fetch scope workflows: ${error.message}`}</p>
        </div>
      )}

      <AddStagedWorkflowForm
        claddingMaterials={claddingMaterials}
        insulationMaterials={insulationMaterials}
        locations={locations}
        showForm={showAddStageWorkflow}
        scopeWorkflow={selectedWorkflow}
        formType={formType}
        onSubmit={onSubmit}
        onHide={onHideStageWorkflow}
        onError={onError}
      />

      <div 
        className={`qr-code-blur-container ${showQRCode ? "qr-code-show" : "qr-code-hide"}`}
        onClick={onHideQRCode}
      >
        <div className="qr-code-container">
          <div className="qr-container">
            <QRCodeSVG size={450} value={scopeQRString} ref={qrCodeRef} />
          </div>
          <input className="qr-code-button" type="button" value="Download" onClick={downloadQRCode} />
          <input className="qr-code-button" type="button" value="Cancel" onClick={onHideQRCode} />
        </div>
      </div>
      

      <ConfirmationAlert
        show={showDeleteConfirmation}
        title="Delete workflow scope."
        subtitle="Are you sure you want to delete this workflow scope? This action cannot be undone."
        onConfirmText="Delete"
        onConfirm={onDeleteWorkflow}
        onCancel={() => onShowDeleteConfirmation(false)}
      />
    </div>
  )
}

export default ScopeWorkflowsSection